import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Drawer,
  notification,
  Row,
  Table
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getUrlParams } from '../../../routes'

import {
  Countries,
  InputBox, copiesList
} from '../../../components/_utils/appUtils'
import { JournalList } from '../../journals/actions'
import { addSubscriptionActivityFxn } from '../action'
import { getGroupedSubscription, journalsAjaxList } from '../../subscription/actions'

@Form.create()
class AddGeneralSubscriptionDrawer extends PureComponent {
  state = {
    name: '',
    journalListArr: [],
    email: '',
    state: '',
    totalAmount: '',
    journals: [],
    journalName: '',
    country: '',
    city: '',
    subscribedBy: '',
    yearOptions: [],
    pincode: '',
    pageNumber: '',
    endUserAddress: '',
    copies: '',
    designation: '',
    contactPerson: '',
    agencyName: '',
    subscriptionData: {},
    journalList: [],
    multipleJournals: [],
    amountDetails: [],
    distinctYears: []
  }
  paymentDetails = {
    receivedDate: '',
    modeOfPayment: '',
    amount: '',
    year: ''

  }

  constructor(props) {
    super(props)

  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journals: [],
      name: '',
      email: '',
      country: '',
      state: '',
      city: '',
      pincode: '',
      subscribeBy: '',
      address: '',
      mobile: '',
      instituteName: '',
      instituteContactPerson: '',
      instituteContactNo: '',
      instituteAddress: '',
      copies: ''
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.amountDetails = this.state.amountDetails
        valData.totalAmount = this.state.totalAmount
        valData.journals = this.state.journals

        let { success, message } = await dispatch(addSubscriptionActivityFxn(valData))

        if (success) {
          notification.success({
            message: message
          })
          this.resetFormData()
          this.props.onClose()
          this.setState({
            name: '',
            email: '',
            country: '',
            state: '',
            city: '',
            pincode: '',
            subscriptionBy: '',
            journals: '',
            pageNumber: '',
            endUserAddress: '',
            designation: '',
            contactPerson: '',
            agencyName: '',
            copies: ''
          })
        }
      }
    })
  }


  handleSubscribeByChange = (val) => {
    const { form } = this.props

    // 1. Reset Form Fields (Keep 'subscribeBy', clear the rest)
    form.setFieldsValue({
      journals: [],
      name: '',
      email: '',
      country: '',
      state: '',
      city: '',
      pincode: '',
      address: '',
      mobile: '',
      instituteName: '',
      instituteContactPerson: '',
      instituteContactNo: '',
      instituteAddress: '',
      copies: '',

      // Clear other fields that might be holding data
      secondaryEmail: '',
      secondaryMobile: '',
      pageNumber: '',
      contactPerson: '',
      designation: '',
      agencyName: '',
      year: undefined
    })

    // 2. Reset State (Keep the list of added journals/amountDetails)
    this.setState({
      // amountDetails: [], // REMOVED: Keep the array of added journals
      // totalAmount: 0,    // REMOVED: Keep calculated total

      // Clear local state variables that mirror form fields
      name: '',
      email: '',
      state: '',
      country: '',
      city: '',
      pincode: '',
      pageNumber: '',
      endUserAddress: '',
      designation: '',
      contactPerson: '',
      agencyName: '',
      copies: '',

      // Update subscribeBy
      subscribedBy: val
    })

    // 3. Update the form field for subscribeBy 
    // (This is redundant if called from onChange, but ensures sync)
    form.setFieldsValue({ subscribeBy: val })
  }

  componentDidMount() {

    this.loadJournalList()
    this.apiGroupedSubscription()
    this.journalAjax()
    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }

  calculateTotalAmount = (multipleJournals) => {
    const { subscriptionData } = this.state
    const { form: { getFieldValue } } = this.props
    let total = 0
    const amountDetails = []
    const journalArray = []

    // Get multiplier from form field 'pageNumber', default to 1 if missing/invalid
    const pageNumberVal = getFieldValue('pageNumber')
    const multiplier = parseFloat(pageNumberVal) || 1

    if (!multipleJournals || multipleJournals.length === 0) {
      return { total, amountDetails }
    }
    multipleJournals.forEach(item => {
      const { journalName, copies, year } = item
      const journals = item.journals || item.journalId
      const journalSubs = subscriptionData[journals] || []
      const sub = journalSubs.find(s => s.year === year)

      let priceInInr = 0
      if (sub) {
        priceInInr = sub.priceInInr
      } else if (journalSubs.length > 0) {
        priceInInr = journalSubs[0].priceInInr
      } else if (item.priceInInr) {
        priceInInr = item.priceInInr
      }

      const copiesCount = parseInt(copies, 10) || 1
      const totalForSub = priceInInr * copiesCount

      total += totalForSub
      amountDetails.push({
        journals,
        journalId: journals,
        journalName,
        copies: copiesCount,
        priceInInr,
        totalForSub,
        year
      })
      journalArray.push(journals)
    })

    // Apply multiplier to the final sum
    // total = total * multiplier;

    this.setState({ journals: journalArray })
    return { total, amountDetails }
  }

  events = {
    removeStateCountry: (index) => {
      let cloneArr = _.clone(this.state.amountDetails)
      cloneArr.splice(index, 1)
      const { year } = this.state

      const { total, amountDetails } = this.calculateTotalAmount(cloneArr)

      this.setState({
        amountDetails,
        totalAmount: total
      })
    }
  }
  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }

  journalAjax = async () => {
    let { dispatch } = this.props
    let { data } = await dispatch(journalsAjaxList())
    this.setState({ journalList: data })
  }

  apiGroupedSubscription = async () => {
    let result = await getGroupedSubscription()
    const data = result.data || {}

    const allItems = Object.values(data).flat()

    const allYears = allItems.map(item => item.year)

    const distinctYears = [...new Set(allYears)]
    this.setState({
      subscriptionData: data,
      distinctYears: distinctYears
    })

  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }

  }

  async AddSubscriptionDetails() {
    const {
      form: { getFieldValue, setFieldsValue }
    } = this.props

    let journals = getFieldValue('journals')
    let copies = getFieldValue('copies')
    let year = getFieldValue('year')

    if (!journals) {
      notification.error({ message: 'Please choose Journal Name.' })
      return
    }
    if (!copies) {
      notification.error({ message: 'Please select copies' })
      return
    }
    if (!year) {
      notification.error({ message: 'Please choose Year.' })
      return
    }

    const journalObj = this.state.journalList.find(j => j._id === journals)

    // Fetch price from subscriptionData
    const { subscriptionData } = this.state
    const journalSubs = subscriptionData[journals] || []
    const sub = journalSubs.find(s => s.year === year)

    // Use price from matched year, or fallback to first available subscription price, or 0
    let priceInInr = 0
    if (sub) {
      priceInInr = sub.priceInInr
    } else if (journalSubs.length > 0) {
      priceInInr = journalSubs[0].priceInInr
    }

    if (!priceInInr && priceInInr !== 0) {
      console.warn('Journal price missing for:', journalObj.name)
    }

    let newItem = {
      journals,
      copies,
      year,
      journalId: journalObj._id,
      journalName: journalObj.name,
      priceInInr
    }
    let clone = _.cloneDeep(this.state.amountDetails)

    const existIndex = clone.findIndex(
      item => item.journals === journals && item.year === year
    )

    if (existIndex !== -1) {
      notification.error({
        message: 'This Journal for the selected Year is already added.'
      })
      return
    } else {
      clone.push(newItem)
    }
    this.setState({ amountDetails: clone })

    setFieldsValue({
      journals: undefined,
      copies: undefined
    })

    const { total, amountDetails } = this.calculateTotalAmount(clone)
    this.setState({ totalAmount: total })

  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const subscribeBy = getFieldValue('subscribeBy')

    let nameLabel = 'Name'
    let contactPersonLabel = 'Contact Person'

    if (['Institute', 'Agency', 'Library'].includes(subscribeBy)) {
      nameLabel = `${subscribeBy} Name`
      contactPersonLabel = `${subscribeBy} Contact Person`
    }
    const { edit, journalListArr, lastArticleNo, subscriptionData } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }


    const inputSchma = {
      fields: [
        {
          label: 'Subscribe By',
          key: 'subscribeBy',
          required: true,
          type: 'select', options: ['Institute', 'Agency', 'Library'],
          onChange: val => {
            this.handleSubscribeByChange(val)
          }
        },
        {
          label: nameLabel,
          key: 'name',
          required: true,
          placeholder: nameLabel
        },
        {
          label: contactPersonLabel,
          key: 'instituteContactPerson',
          required: true,
          placeholder: contactPersonLabel
        },
        {
          label: 'Primary Email',
          key: 'email',
          required: true,
          type: 'email',
          placeholder: 'Primary Email'
        },
        {
          label: 'Secondary Email',
          key: 'secondaryEmail',
          required: false,
          type: 'email',
          placeholder: 'Secondary Email'
        },
        {
          label: 'Primary Mobile',
          key: 'mobile',
          required: true,
          placeholder: 'Primary Mobile'
        },
        {
          label: 'Secondary Mobile',
          key: 'secondaryMobile',
          required: false,
          placeholder: 'Secondary Mobile'
        },
        {
          label: 'Pincode',
          key: 'pincode',
          required: true,
          placeholder: 'pincode'
        },
        {
          label: 'Address',
          key: 'address',
          required: true,
          placeholder: 'Address',
          span: 18
        },
        {
          label: 'Country',
          key: 'country',
          required: true,
          showSearch: true,
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Country',
          type: 'select',
          onChange: val => {
            setFieldsValue({ country: val })
          },
          span: 6
        },
        {
          label: 'State',
          key: 'state',
          required: true,
          placeholder: 'State',
          span: 6
        },
        {
          label: 'City',
          key: 'city',
          required: true,
          placeholder: 'City',
          span: 6

        },
        {
          label: 'Page Number',
          key: 'pageNumber',
          required: true,
          placeholder: 'Page Number'
        },

        {
          label: 'Contact Person',
          key: 'contactPerson',
          required: true,
          placeholder: 'Contact Person',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },
        {
          label: 'Designation',
          key: 'designation',
          required: true,
          placeholder: 'Designation',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },
        {
          label: 'Agency Name',
          key: 'agencyName',
          required: true,
          placeholder: 'Agency Name',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },

        // removed End User Address Field
        //   label: 'End User Address',
        //   key: 'endUserAddress',
        //   placeholder: 'End User Address'
        // ,

        {
          label: 'Institute Name',
          key: 'instituteName',
          placeholder: 'Institute Name',
          hidden: true

        },
        {
          label: 'Institute Contact Person',
          key: 'instituteContactPerson',
          placeholder: 'Institute Contact Person',
          hidden: true

        },
        {
          label: 'Institute Address',
          key: 'instituteAddress',
          placeholder: 'Institute Address',
          hidden: true

        },
        {
          label: 'Institute Contact No',
          key: 'instituteContactNo',
          placeholder: 'Institute Contact No',
          hidden: true
        },

        {
          label: 'Year',
          key: 'year',
          type: 'select',
          options: this.state.distinctYears,
          allowClear: true,
          placeholder: 'Year',
          required: true,
          keyAccessor: x => x,
          valueAccessor: x => x,
          onChange: (val) => {
            setFieldsValue({ year: val })
          }

        }

      ]
    }
    let multiFields = [
      {
        label: 'Journal of Interest',
        key: 'journals',

        showSearch: true,
        options: this.state.journalList,
        keyAccessor: x => x._id,
        valueAccessor: x => x.name,
        placeholder: 'Journal',
        type: 'select',
        onChange: val => {
          setFieldsValue({ journals: val })
          const selectedJournalId = val && val
          const relatedYears = subscriptionData[selectedJournalId] && subscriptionData[selectedJournalId].map(item => item.year) || []
          this.setState({ yearOptions: relatedYears })

        }

      },
      {
        label: 'Copies',
        key: 'copies',

        type: 'select', options: copiesList,
        onChange: val => {
          setFieldsValue({ copies: val })
        }
      },
      {
        key: 'add',
        span: 4,
        customField: (
          <InputBox title={'Add'}>
            <a className='btn ' type='primary'
               onClick={() => {
                 this.AddSubscriptionDetails()
               }}
               style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white', marginBottom: '6px' }}>
              ADD
            </a>
          </InputBox>
        )
      }
    ]

    const assignColumns = [
      {
        title: 'Journal Name',
        key: 'journalName',
        dataIndex: 'journalName'
      },
      {
        title: 'Copies',
        key: 'copies',
        dataIndex: 'copies'
      },


      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        render: (item, record, index) => {
          return (
            <Icon type={'close'}
                  style={{ color: 'red' }}
                  onClick={() => {
                    this.events.removeStateCountry(index)
                  }} />
          )
        }
      }

    ]

    return (
      <Drawer
        title={'Add Journal Subscription'}
        width={'60%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card size={'small'}>
          <Form onSubmit={this.handleSubmit}
                noValidate={true}
                hideRequiredMark
                className={'inputForm'}>
            <Card bordered={true} size={'small'}>
              <Row gutter={16}>
                {inputSchma.fields.map((item, key) => {
                  return (
                    !item.hidden && (
                      <Col
                        span={item.span ? item.span : 6}
                        md={item.span ? item.span : 6}
                        sm={12}
                        xs={24}
                        key={key}>
                        {item.customField ? (
                          item.customField
                        ) : (
                          <GetEachFormFields
                            item={item}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}
                          />
                        )}
                      </Col>
                    )
                  )
                })}
              </Row>

            </Card>
            <Card bordered={true} size={'small'} className={'mt10'}>
              <Row gutter={16}>
                {multiFields.map((item, key) => {
                  return (
                    !item.hidden && (
                      <Col
                        span={item.span ? item.span : 6}
                        md={item.span ? item.span : 6}
                        sm={8}
                        xs={24}
                        key={key}>
                        {item.customField ? (
                          item.customField
                        ) : (
                          <GetEachFormFields
                            item={item}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}
                          />
                        )}
                      </Col>
                    )
                  )
                })}
                <Col span={24}>
                  <Table dataSource={this.state.amountDetails}
                         className={'table table-bordered'}
                         bordered={true} size={'small'}
                         pagination={false} columns={assignColumns} />
                </Col>
              </Row>
            </Card>


            <div className={'d-flex jcsb'}>
              <Form.Item className={'mt10'}>
                <Button type='primary' htmlType='submit'>
                  SUBMIT
                </Button>
              </Form.Item>

              {this.state && this.state.totalAmount > 0 && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0', marginTop: '0px' }}>
                    <div style={{ padding: '12px', background: '#f5f5f5', borderRadius: '4px' }}>

                      <p style={{ margin: 0, fontWeight: 'bold' }}>
                        Total Amount - INR {this.state && this.state.totalAmount}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddGeneralSubscriptionDrawer)
